export const IMAGES = {
  hero: "/hero-srilanka.jpg",
  aboutLeaf: "https://images.unsplash.com/photo-1742281095650-dd3c50c08772?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  aboutCurry: "https://images.unsplash.com/photo-1606843046080-45bf7a23c39f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  menuHighlight: "https://images.pexels.com/photos/17104944/pexels-photo-17104944.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  spices: "https://images.pexels.com/photos/7956506/pexels-photo-7956506.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
};

export const ALLERGENS = {
  A: "glutenhaltiges Getreide", B: "Krebstiere", C: "Eier", D: "Fisch",
  E: "Erdnüsse", F: "Soja", G: "Milch/Laktose", H: "Schalenfrüchte",
  I: "Sellerie", J: "Senf", K: "Sesam", L: "Schwefeldioxid/Sulfite",
  M: "Lupinen", N: "Weichtiere",
};

export const ZUSATZ = {
  1: "mit Farbstoff", 2: "koffeinhaltig", 3: "mit Süßungsmittel(n)",
};

export const SIGNATURES = [
  {
    name: "Chicken Biryani",
    tag: "Beliebt",
    desc: "Duftender Basmati-Reis mit Hähnchen und Biryani-Gewürzen, serviert mit Raita.",
    img: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    name: "Butter Chicken",
    tag: "Signature",
    desc: "Zartes Hähnchen in cremiger Tomaten-Butter-Sauce.",
    img: "https://images.unsplash.com/photo-1722612114203-17110f747244?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    name: "Chicken Kottu",
    tag: "Srilankisch",
    desc: "Gehacktes Parotta-Fladenbrot, vermischt mit Chicken Curry, Gemüse und Ei.",
    img: "https://images.unsplash.com/photo-1619714604987-2f6caead7850?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    name: "Veg. Samosa",
    tag: "Vorspeise",
    desc: "Gefüllte Teigtaschen mit Kartoffelcurry, Frühlingszwiebeln und Erbsen.",
    img: "https://images.pexels.com/photos/37153389/pexels-photo-37153389.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  },
];

export const SIGNATURE_ITEMS = [
  { n: 61, name: "Rainbow Idli Box – mit Sambar & Sambol", a: "A", p: 13.90, desc: "5 gedämpfte Idli aus fermentiertem Reis-Linsen-Teig: Klassisch, Rote Beete, Spinat, Karotten & Masala Fried Idli" },
  { n: 65, name: "Rainbow Idli Box – mit Chicken Chettinad", a: "A,H,J", p: 15.90, desc: "5 Idli wie oben, dazu kräftig gewürztes südindisches Chicken Chettinad" },
  { n: 62, name: "Veg Idiyappam Kottu", a: "A,C,J", p: 13.90, desc: "Gedämpfte Reisnudeln (String Hoppers) mit aromatischem vegetarischem Curry und Ei" },
  { n: 63, name: "Chicken Idiyappam Kottu", a: "A,C,J", p: 14.90, desc: "String Hoppers mit würzigem Chicken Curry und Ei" },
  { n: 64, name: "Lamb Idiyappam Kottu", a: "A,C,J", p: 16.90, desc: "String Hoppers mit Lamm Curry und Ei" },
];

export const MENU = [
  {
    id: "vorspeisen", title: "Vorspeisen", roman: "I",
    items: [
      { n: 1, name: "Vadai (3 Stück)", a: "A,G", p: 5.90, desc: "Traditionelle Linsenringe goldbraun frittiert und mit aromatischen Gewürzen verfeinert" },
      { n: 2, name: "Veg. Samosa (2 Stück)", a: "A", p: 4.90, desc: "Gefüllte Teigtaschen mit Kartoffelcurry, Frühlingszwiebeln und Erbsen" },
      { n: 3, name: "Beef Samosa (2 Stück)", a: "A", p: 5.90, desc: "Gefüllte Teigtaschen mit Kartoffelcurry und Rinderhackfleisch" },
      { n: 4, name: "Veg. Rolls (2 Stück)", a: "A", p: 4.90, desc: "Sri-lankische panierte Rollen mit Kartoffelcurry, Frühlingszwiebeln und Erbsen" },
      { n: 5, name: "Beef Rolls (2 Stück)", a: "A", p: 5.90, desc: "Sri-lankische panierte Rollen mit Kartoffelcurry und Rinderhackfleisch" },
      { n: 6, name: "Mini Spring Rolls (6 Stück)", a: "A", p: 6.90, desc: "Knusprige vegetarische Mini-Frühlingsrollen" },
      { n: 7, name: "Chicken Pakora (6 Stück)", a: "", p: 6.90, desc: "Würzig marinierte Hähnchenbruststücke im knusprigen Kichererbsenteig" },
      { n: 8, name: "Fish Cutlets (3 Stück)", a: "A,D", p: 6.90, desc: "Knusprig frittierte Bällchen mit würziger Füllung aus Thunfisch und Kartoffelcurry" },
      { n: 9, name: "Fish Pakora (6 Stück)", a: "D", p: 7.90, desc: "Aromatisch gewürzter Fisch im knusprigen Kichererbsenteig" },
      { n: 10, name: "Prawn Pakora (7 Stück)", a: "B", p: 8.90, desc: "Saftige Garnelen im würzigen, knusprigen Kichererbsenteig" },
    ],
  },
  {
    id: "veg-currys", title: "Vegetarische Currys", roman: "II",
    items: [
      { n: 11, name: "Dal Curry", a: "G,J", p: 13.90, desc: "Aromatische Linsen, in Ghee mit Gewürzen geröstet, in cremigem Ceylon-Curry verfeinert" },
      { n: 12, name: "Bhindi Masala", a: "J", p: 14.90, desc: "Okra in aromatischer Masala-Sauce" },
      { n: 13, name: "Palak Paneer", a: "G,J", p: 14.90, desc: "Indischer Frischkäse in cremigem Spinatcurry" },
      { n: 14, name: "Mango Paneer", a: "G,J", p: 14.90, desc: "Paneer in cremig-fruchtiger Mango-Currysauce" },
      { n: 15, name: "Chana Masala", a: "G,J", p: 13.90, desc: "Kichererbsen und Kartoffelstücke in würziger Tomaten-Masala-Sauce" },
    ],
  },
  {
    id: "chicken-currys", title: "Chicken Currys", roman: "III",
    items: [
      { n: 16, name: "Butter Chicken", a: "G,H,J", p: 15.90, desc: "Zartes Hähnchen in cremiger Tomaten-Butter-Sauce" },
      { n: 17, name: "Mango Chicken", a: "G,J", p: 15.90, desc: "Zartes Hähnchen in fruchtig-cremiger Mango-Currysauce" },
      { n: 18, name: "Dal Chicken", a: "G,J", p: 15.90, desc: "Zartes Hähnchen in würzigem Linsen-Curry" },
      { n: 19, name: "Bhindi Chicken", a: "J", p: 16.90, desc: "Zartes Hähnchen mit Okra in würziger Masala-Sauce" },
      { n: 20, name: "Chicken Chettinad", a: "H,J", p: 16.90, desc: "Kräftig gewürztes südindisches Hähnchencurry" },
      { n: 21, name: "Palak Chicken & Paneer", a: "G,J", p: 16.90, desc: "Hähnchen und Paneer in cremigem Spinatcurry" },
      { n: 22, name: "Chicken Chana", a: "J", p: 15.90, desc: "Hähnchen, Kichererbsen und Kartoffelstücke in aromatischer Masala-Sauce" },
    ],
  },
  {
    id: "lamm-currys", title: "Lamm Currys", roman: "IV",
    items: [
      { n: 23, name: "Lamb Korma", a: "G,H,J", p: 16.90, desc: "Zartes Lamm in milder, cremiger Sauce mit Cashews und Mandeln" },
      { n: 24, name: "Dal Lamb", a: "G,J", p: 16.90, desc: "Zartes Lamm in würzigem Linsen-Curry" },
      { n: 25, name: "Spinach Lamb", a: "G,J", p: 16.90, desc: "Zartes Lamm in cremigem Spinatcurry" },
      { n: 26, name: "Lamb Chettinad", a: "H,J", p: 17.90, desc: "Kräftig gewürztes südindisches Lammcurry" },
      { n: 27, name: "Lamb Chana Masala", a: "J", p: 16.90, desc: "Zartes Lamm, Kichererbsen und Kartoffelstücke in aromatischer Masala-Sauce" },
    ],
  },
  {
    id: "seafood", title: "Seafood", roman: "V",
    items: [
      { n: 28, name: "Ceylon Prawn Masala", a: "B,J", p: 17.90, desc: "Saftige Garnelen in aromatischer Ceylon-Masala-Sauce" },
      { n: 29, name: "Ceylon Tuna Steak Curry", a: "D,J", p: 18.90, desc: "Thunfischsteak in aromatischer Ceylon-Currysauce" },
    ],
  },
  {
    id: "kottu", title: "Kottu Roti", roman: "VI",
    items: [
      { n: 30, name: "Veg Kottu Roti", a: "A,C", p: 13.90, desc: "Gehacktes Parotta-Fladenbrot, vermischt mit Gemüse, Ei und aromatischem Curry" },
      { n: 31, name: "Chicken Kottu", a: "A,C", p: 14.90, desc: "Gehacktes Parotta-Fladenbrot, vermischt mit Chicken Curry, Gemüse und Ei" },
      { n: 32, name: "Lamb Kottu", a: "A,C", p: 16.90, desc: "Gehacktes Parotta-Fladenbrot, vermischt mit Lamb Curry, Gemüse und Ei" },
    ],
  },
  {
    id: "biryani", title: "Biryani", roman: "VII",
    items: [
      { n: 33, name: "Veg Biryani", a: "G", p: 13.90, desc: "Duftender Basmati-Reis mit Gemüse und Gewürzen, serviert mit Raita" },
      { n: 34, name: "Chicken Biryani", a: "G", p: 14.90, desc: "Duftender Basmati-Reis mit Hähnchen und Biryani-Gewürzen, serviert mit Raita" },
      { n: 35, name: "Lamb Biryani", a: "G", p: 16.90, desc: "Duftender Basmati-Reis mit Lamm und Biryani-Gewürzen, serviert mit Raita" },
    ],
  },
  {
    id: "beilagen", title: "Beilagen & Suppen", roman: "VIII",
    items: [
      { n: 40, name: "Basmati Reis", a: "", p: 3.50, desc: "Locker gedämpfter, aromatischer Basmati-Reis" },
      { n: 41, name: "Butter Naan", a: "A", p: 2.90, desc: "Frisch gebackenes indisches Fladenbrot" },
      { n: 42, name: "Garlic Naan", a: "A", p: 3.50, desc: "Naan mit Knoblauch" },
      { n: 43, name: "Cheese Naan", a: "A,G", p: 3.90, desc: "Naan gefüllt mit geschmolzenem Käse" },
      { n: 44, name: "Garlic Cheese Naan", a: "A,G", p: 4.50, desc: "Naan mit Käse und Knoblauch" },
      { n: 45, name: "Chapati", a: "A", p: 2.90, desc: "Traditionelles dünnes Fladenbrot" },
      { n: 46, name: "Spinatsuppe", a: "G", p: 5.50, desc: "Cremige Suppe aus frischem Spinat und aromatischen Gewürzen" },
      { n: 47, name: "Linsensuppe", a: "G", p: 5.50, desc: "Wärmende Linsensuppe mit aromatischen Gewürzen" },
    ],
  },
  {
    id: "dips", title: "Dips & Extras", roman: "IX",
    items: [
      { n: 48, name: "Mango Chutney", a: "J", p: 1.50, desc: "Fruchtig-würziges Mango-Chutney" },
      { n: 49, name: "Mint & Coriander Dip", a: "G,J", p: 1.50, desc: "Frischer Minz-Koriander-Dip" },
      { n: 50, name: "Raita", a: "G", p: 2.50, desc: "Erfrischender Joghurt-Dip" },
      { n: 51, name: "Süß-Sauer Sauce", a: "J", p: 1.50, desc: "" },
    ],
  },
  {
    id: "desserts", title: "Desserts", roman: "X",
    items: [
      { n: 36, name: "Ben & Jerry's Cookie Dough (100 ml)", a: "A,G", p: 4.90, desc: "Cremiges Vanilleeis mit Keksteig- und Schokostückchen" },
      { n: 37, name: "Sri Lankan Banana Pops (4 Stück)", a: "A", p: 5.90, desc: "Traditionelle süße Bananenbällchen" },
      { n: 38, name: "Coconut Cream Sweet Idli (3 Stück)", a: "A,G", p: 6.90, desc: "Gedämpfte süße Idlis mit cremiger Kokosfüllung" },
      { n: 39, name: "Payasam", a: "G,H", p: 4.90, desc: "Traditionelles cremiges südindisches Milchdessert mit Rosinen und Cashews" },
    ],
  },
  {
    id: "getraenke", title: "Lassis & Softdrinks", roman: "XI",
    items: [
      { n: 52, name: "Mango Lassi", a: "G", p: 4.90, desc: "Cremiger Mango-Joghurt-Drink · 0,4 l" },
      { n: 53, name: "Ceylon Rose Falooda", a: "G", p: 5.50, desc: "Rosenmilch mit Chiasamen und Jelly, gekrönt mit einer Kugel Vanilleeis · 0,4 l" },
      { n: 54, name: "Milo Lassi", a: "G", p: 5.50, desc: "Cremiger Joghurt-Drink mit malzig-schokoladigem Milo · 0,4 l" },
      { n: 55, name: "Mandel-Dattel Lassi", a: "G", p: 5.50, desc: "Cremiger Joghurt-Drink mit Mandeln und süßen Datteln · 0,4 l" },
      { n: 56, name: "Coca-Cola (0,5 l)", a: "1,2", p: 2.50, desc: "Auch als 1,0 l für 3,50 € erhältlich" },
      { n: 57, name: "Coca-Cola Zero (0,5 l)", a: "1,2,3", p: 2.50, desc: "Auch als 1,0 l für 3,50 € erhältlich" },
      { n: 58, name: "Fanta (0,5 l)", a: "1,3", p: 2.50, desc: "Auch als 1,0 l für 3,50 € erhältlich" },
      { n: 59, name: "Sprite (0,5 l)", a: "3", p: 2.50, desc: "Auch als 1,0 l für 3,50 € erhältlich" },
      { n: 60, name: "Mezzo Mix (0,5 l)", a: "1,2,3", p: 2.50, desc: "Auch als 1,0 l für 3,50 € erhältlich" },
    ],
  },
];

export const DELIVERY_PLZ = [
  "76131", "76133", "76135", "76137", "76139", "76149", "76185",
  "76187", "76189", "76199", "76227", "76228", "76229", "76275",
];

export const CONTACT = {
  address: "Wilhelmstraße 43, 76137 Karlsruhe",
  hours: "Mo – Sa 16:00 – 02:00 Uhr · So 12:00 – 01:00 Uhr",
  phone: "0176 70131853",
  phoneHref: "tel:+4917670131853",
  email: "info@ceylonroyal.de",
  website: "www.ceylonroyal.de",
  googleReviewUrl: "https://g.page/r/CcGfSH1bjB0hEBM/review",
};

export const eur = (n) => n.toFixed(2).replace(".", ",") + " €";
